import Container from '@/app/[locale]/bar/Container';
import { SearchProductAttribute } from '@winelivery-org/wl-client-sdk-js/dist/models/search';
import Filters from './Filters';
import Nav from './Nav';

interface Props {
  storeId: string;
  categoryName: string;
  subcategories: SearchProductAttribute[];
  activeSubcategory: string;
  onClick: (subcategory: string) => void;
}

export default function Header(props: Props) {
  return (
    <header className="sticky top-0 z-10 bg-white border-b border-greyscale-separator">
      <Container>
        <Nav storeId={props.storeId} title={props.categoryName} />
        <Filters
          subcategories={props.subcategories}
          activeSubcategory={props.activeSubcategory}
          onChange={props.onClick}
        />
      </Container>
    </header>
  );
}
